export const NAME = 'common'

/**
 * hopefully the name is clear: this is some deprecated legacy nonsense.
 * don't use it except to support legacy functionality where it's not worth it to refactor yet
 *
 * @type {Readonly<{DISMISSED: string, EMAIL_NOTIFICATIONS: string, SUBSCRIBED: string}>}
 */
export const LEGACY = Object.freeze({
  SUBSCRIBED: 'subscribed',
  DISMISSED: 'dismissed',
  EMAIL_NOTIFICATIONS: 'email_notifications'
})

export const COMMON_TABLE_HEADERS = {
  NAME: 'Name',
  LOCATION_NAME: 'Location Name',
  ADDRESS: 'Address',
  ADDRESS_1: 'Address 1',
  ADDRESS_2: 'Address 2',
  CITY: 'City',
  STATE: 'State',
  ZIP: 'Zip',
  COUNTRY: 'Country',
  VERIFIED: 'Verified',
  UNVERIFIED: 'Unverified'
}

export default {
  NAME
}
